import React from "react";

interface SiteHeroProps {
  title: string;
  subtitle: string;
  ctaLabel: string;
  ctaHref: string;
  ctaSecondaryLabel?: string;
  ctaSecondaryHref?: string;
}

const HERO_ART = [
  { emoji: "🎮", bg: "linear-gradient(160deg,#001428,#002a50)", glow: "#00b4ff" },
  { emoji: "🕹️", bg: "linear-gradient(160deg,#001a20,#003040)", glow: "#00ffea" },
  { emoji: "⚡",  bg: "linear-gradient(160deg,#101828,#1a2a40)", glow: "rgba(255,255,255,0.8)" },
];

export default function SiteHero({
  title,
  subtitle,
  ctaLabel,
  ctaHref,
  ctaSecondaryLabel,
  ctaSecondaryHref,
}: SiteHeroProps) {
  return (
    <header className="hero">
      <div className="hero-copy">
        <span className="hero-eyebrow">// Free Browser Games</span>
        <h1>
          {title.split(",")[0]},<br />
          <span className="hero-accent">{title.split(",")[1]?.trim()}</span>
        </h1>
        <p>{subtitle}</p>
        <div className="hero-ctas">
          <a href={ctaHref} className="cta">{ctaLabel}</a>
          {ctaSecondaryLabel && ctaSecondaryHref && (
            <a href={ctaSecondaryHref} className="cta cta--ghost">{ctaSecondaryLabel}</a>
          )}
        </div>
      </div>

      <div className="hero-art">
        {HERO_ART.map((m) => (
          <div
            key={m.emoji}
            style={{
              width: 100, height: 100, borderRadius: 24,
              background: m.bg,
              border: `2px solid ${m.glow}`,
              boxShadow: `0 0 20px ${m.glow}, 0 0 60px ${m.glow}40`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "2.5rem",
            }}
          >
            {m.emoji}
          </div>
        ))}
      </div>
    </header>
  );
}
